<template>
  <div>
    <div class="main">
      <div class="progress1" v-if="type==='Tool'" v-for="(task,index) in taskList">
        <!--         结束-->
        <div class="leftDiv" v-if="task.statusId===4||task.statusId===5">
          <svg class="left1" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>对勾#merge#</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="进展查询-病毒" transform="translate(-28.000000, -198.000000)" fill="#5878FA" fill-rule="nonzero">
                <g id="对勾#merge#" transform="translate(28.000000, 198.000000)">
                  <path d="M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z" id="形状"></path>
                </g>
              </g>
            </g>
          </svg>
          <div class="div" v-if="index<taskModules.length"/>
        </div>
        <!--        未开始-->
        <div class="leftDiv" v-if="task.statusId===0">
          <div class="colorDiv_2 left1" />
          <div v-if="index<taskModules.length" class="div div_2" />
        </div>
        <!--        进行中-->
        <div class="leftDiv" v-if="task.statusId===1">
          <svg class="left1" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>编组#merge#</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="进展查询-病毒" transform="translate(-28.000000, -270.000000)">
                <g id="编组#merge#" transform="translate(28.000000, 270.000000)">
                  <circle id="椭圆形" fill="#5878FA" cx="7" cy="7" r="7"></circle>
                  <circle id="椭圆形" fill="#FFFFFF" cx="7" cy="7" r="1"></circle>
                  <circle id="椭圆形备份" fill="#FFFFFF" cx="9.8" cy="7" r="1"></circle>
                  <circle id="椭圆形备份-2" fill="#FFFFFF" cx="4.2" cy="7" r="1"></circle>
                </g>
              </g>
            </g>
          </svg>
          <div class="div" v-if="index<taskModules.length"/>
        </div>
        <div class="block_3">
          <span class="plasmidExtraction" :class="[task.statusId===0?'color_gray':'color_black']">{{task.name}}</span>
          <div class="outer_2">
            <span class="completionTime" :lines="undefined">
              <span v-if="task.statusId!==0&&task.statusId!==1">完成时间</span>
              <span v-else :class="[task.statusId===0?'color_gray':'color_blue']">预计完成时间</span>
            </span>
            <span class="text" :lines="undefined">
              <span v-if="task.statusId!==0&&task.statusId!==1">{{task.realEndDate.replace('.','-')}}</span>
              <span v-else :class="[task.statusId===0?'color_gray':'color_blue']">{{task.planEndDate.replace('.','-')}}</span>
            </span>
          </div>
        </div>
    </div>
      <div class="progress1" v-if="type==='Service'" v-for="(task,index) in taskList">
        <!--         结束-->
        <div class="leftDiv" v-if="task.taskStatus==='结束'||task.taskStatus==='终止'">
          <svg class="left1" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>对勾#merge#</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="进展查询-病毒" transform="translate(-28.000000, -198.000000)" fill="#5878FA" fill-rule="nonzero">
                <g id="对勾#merge#" transform="translate(28.000000, 198.000000)">
                  <path d="M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z" id="形状"></path>
                </g>
              </g>
            </g>
          </svg>
          <div class="div" v-if="index+1+expressOutListLength<taskModules.length"/>
        </div>
        <!--        未开始-->
        <div class="leftDiv" v-if="task.taskStatus==='无法开始'||task.taskStatus==='准备开始'">
          <div class="colorDiv_2 left1" />
          <div v-if="index+1+expressOutListLength<taskModules.length" class="div div_2" />
        </div>
        <!--        进行中-->
        <div class="leftDiv" v-if="task.taskStatus==='进行中'">
          <svg class="left1" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>编组#merge#</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="进展查询-病毒" transform="translate(-28.000000, -270.000000)">
                <g id="编组#merge#" transform="translate(28.000000, 270.000000)">
                  <circle id="椭圆形" fill="#5878FA" cx="7" cy="7" r="7"></circle>
                  <circle id="椭圆形" fill="#FFFFFF" cx="7" cy="7" r="1"></circle>
                  <circle id="椭圆形备份" fill="#FFFFFF" cx="9.8" cy="7" r="1"></circle>
                  <circle id="椭圆形备份-2" fill="#FFFFFF" cx="4.2" cy="7" r="1"></circle>
                </g>
              </g>
            </g>
          </svg>
          <div class="div" v-if="index+1+expressOutListLength<taskModules.length"/>
        </div>

        <div class="block_3">
          <span class="plasmidExtraction" :class="[task.taskStatus!=='无法开始'&&task.taskStatus!=='准备开始'?'color_black':'color_gray']">{{task.taskName}}</span>
          <div class="outer_2">
            <span class="completionTime" :lines="undefined">
              <span v-if="task.taskStatus==='结束'||task.taskStatus==='终止'">完成时间</span>
              <span v-else :class="[task.taskStatus==='进行中'?'color_blue':'color_gray']">预计完成时间</span>
            </span>
            <span class="text" :lines="undefined">
              <span v-if="task.taskStatus==='结束'||task.taskStatus==='终止'">{{task.actualEnd}}</span>
              <span v-else :class="[task.taskStatus==='进行中'?'color_blue':'color_gray']">{{task.expectedEnd}}</span>
            </span>
          </div>
        </div>

      </div>
      <div class="progress1" v-if="expressOutListLength>0">

        <!--         结束-->
        <div class="leftDiv">
          <svg class="left1" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>对勾#merge#</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="进展查询-病毒" transform="translate(-28.000000, -198.000000)" fill="#5878FA" fill-rule="nonzero">
                <g id="对勾#merge#" transform="translate(28.000000, 198.000000)">
                  <path d="M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z" id="形状"></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="block_3">
          <span class="plasmidExtraction" :lines="undefined">发货</span>
          <div class="outer_2">
            <span class="completionTime" :lines="undefined">
<!--              已寄出-->
              <span v-if="expressOutList[0].sendStatusID===1">完成时间</span>
              <span v-else>预计完成时间</span>
            </span>

            <span class="text" :lines="undefined" v-if="expressOutList[0].sendDTString!=undefined">
               <span v-if="expressOutList[0].sendStatusID===1">{{expressOutList[0].sendDTString.split(' ')[0]}}</span>
              <span v-else>{{expressOutList[0].sendDTString.split(' ')[0]}}</span>
            </span>
            <span class="text" :lines="undefined" v-if="expressOutList[0].sendDTString==undefined">
              无
            </span>
          </div>
        </div>
        <div class="container_4" style="width: 18vw;border-color: #5878FA" @click="toExpress" v-show="expressOutList.length>0">
          <span class="tag_2" style="color:#5878FA" :lines="undefined" >物流信息</span>
        </div>
      </div>
    </div>
<!--    <div class="mod1" v-show="isShow">-->
<!--      <div class="bg"></div>-->
<!--      <div class="container1">-->
<!--        <span class="summary1" :lines="undefined">您的实验报告保存在吉凯云中，请复制下载链接后在PC端浏览器中打开链接下载</span>-->
<!--        <div class="outer1">-->
<!--          <div class="tagWrap1" @click="changeShow(false)">-->
<!--            <span class="tag1" :lines="undefined" >取消</span>-->
<!--          </div>-->
<!--          <div class="tagWrap_21">-->
<!--            <span class="tag_21" :lines="undefined">复制</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
  export default {
    name: 'TaskProgress',
    props: {
      type: String,
      subType: Boolean,
      taskModules: Array,
      expressOutList: Array
    },
    data () {
      return {
        isShow: false
      }
    },
    computed: {
      taskList () {
        if (this.taskModules !== undefined) {
          let tasks = this.taskModules
          let _this = this
          tasks.sort(function (a, b) {
            let aTimeString = ''
            let bTimeString = ''
            if (_this.type === 'Service') {
              if (a.taskStatus === '结束' || a.taskStatus === '终止') {
                aTimeString = a.actualEnd
              } else {
                aTimeString = a.expectedEnd
              }
              if (b.taskStatus === '结束' || b.taskStatus === '终止') {
                bTimeString = b.actualEnd
              } else {
                bTimeString = b.expectedEnd
              }
            } else {
              if (a.statusId === 4 || a.statusId === 5) {
                aTimeString = a.realEndDate
              } else {
                aTimeString = a.planEndDate
              }
              if (b.statusId === 4 || b.statusId === 5) {
                bTimeString = b.realEndDate
              } else {
                bTimeString = b.planEndDate
              }
            }
            let aTime = new Date(aTimeString).getTime()
            let bTime = new Date(bTimeString).getTime()
            if (_this.type === 'Tool') {
              aTime = new Date(aTimeString.replace('.', '-')).getTime()
              bTime = new Date(bTimeString.replace('.', '-')).getTime()
            }
            return aTime - bTime
          })
          console.log('taskList', tasks)
          return tasks
        } else {
          return []
        }
      },
      expressOutListLength () {
        var len = this.expressOutList ? this.expressOutList.length : 0
        return len
      }
    },
    methods: {
      changeShow: function (status) {
        this.isShow = status
      },
      toExpress: function () {
        this.$router.push({name: 'ExpressInfo', query: {expressOutList: this.expressOutList}})
      }
    }
  }
</script>

<style scoped>
  .main {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    top: 2.67vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 93.67vw;
    bottom: 2vw;
    overflow-y:scroll;
  }
  .progress1 {
    margin-left: 4vw;
    margin-top: 1.77vh;
    position: relative;
  }
  .leftDiv {
    position: relative;
    height: 15.8vw;
  }
  .left1 {
    position: absolute;
    z-index: 9;
  }
  .div {
    position: absolute;
    top: 2.67vw;
    left: 1.53vw;
    border-left-width: 2px;
    border-left-style: solid;
    border-left-color: rgba(88, 120, 250, 1);
    width: 0.8vw;
    height: 17.8vw;
    z-index: 1;
  }

  .block_3 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: -28.27vw;
    margin-left: 6.4vw;
    width: 77.27vw;
    height: 28.6vw;
  }
  .color_gray {
    color:#979797 !important;
  }
  .plasmidExtraction {
    opacity: 1;
    max-width: 42.4vw;
    height: 5.33vw;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    line-height: 5.33vw;
    /*white-space: nowrap;*/
    font-size: 3.73vw;
    font-weight: 500;
    color: #424242;
  }
  .color_black {
    color: #424242!important;
  }
  .color_blue {
    color: #5878fa!important;
  }
  .outer_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 5.33vw;
  }

  .completionTime {
    opacity: 1;
    margin-right: 2.67vw;
    max-width: 20.8vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .text {
    opacity: 1;
    max-width: 31.2vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }
  .finishColor{
    color: #5878fa!important;
  }
  .unfinishColor{
    colr: #979797!important;
  }
  .finishBorderColor{
    border-color: #5878fa!important;
  }
  .unfinishBorderColor{
    border-color: #979797!important;
  }
  .colorDiv_2 {
    position: absolute;
    top: 0vw;
    left: 0.67vw;
    align-self: center;
    border-radius: 2.13vw;
    background-color: #efeef3;
    width: 2.13vw;
    height: 2.13vw;
  }

  .div_2 {
    border-left-color: rgba(239, 238, 243, 1);
    z-index: 1;
  }



  .container_4 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: -9.67vw;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.93vw;
    border-color: rgba(151, 151, 151, 1);
    width: 28.53vw;
    height: 6.13vw;
    margin-left: 6vw;
    padding-left: 2vw;
    z-index:5;
    margin-bottom: 5vw;
  }


  .info_2 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }


  .tag_2 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }
  .mod1 {

  }
  .bg {
    position: fixed;
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100vw;
    height: 216.53vw;
    background-color: lightgray;
    z-index: 10;
    opacity: 0.6;
    top: 0;
    left: 0vw;
  }

  .container1 {
    display: flex;
    position: fixed;
    top: 50vw;
    left: 13.33vw;
    align-items: center;
    flex-direction: column;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 73.33vw;
    height: 62.4vw;
    z-index: 11;
  }

  .summary1 {
    webkit-line-clamp: 3px;
    position: relative;
    opacity: 1;
    margin-top: 7.73vw;
    width: 57.6vw;
    height: 27.2vw;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    line-height: 9.07vw;
    color: #424242;
    font-size: 4.8vw;
    font-weight: 500;
  }

  .outer1 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 7.47vw;
    width: 60vw;
    height: 13.33vw;
  }

  .tagWrap1 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 2.67vw;
    background-color: #eeeeee;
    padding-right: 9.6vw;
    padding-left: 9.6vw;
    height: 13.33vw;
  }

  .tag1{
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .tagWrap_21 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 2.67vw;
    background-color: #5878fa;
    padding-right: 9.6vw;
    padding-left: 9.6vw;
    height: 13.33vw;
  }

  .tag_21 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 3.73vw;
    font-weight: 400;
  }

</style>



// WEBPACK FOOTER //
// TaskProgress.vue?ddfa27a2